const InsufficientAccess : React.FC<{}> = () => {
    return <div style={{margin: 'auto'}}>
        You do not have access to view Invoices. Please contact your Account Admin.
    </div>
}

export default InsufficientAccess;